import { render, staticRenderFns } from "./demandHall.vue?vue&type=template&id=45235a4c&scoped=true"
import script from "./demandHall.vue?vue&type=script&lang=js"
export * from "./demandHall.vue?vue&type=script&lang=js"
import style0 from "./demandHall.vue?vue&type=style&index=0&id=45235a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45235a4c",
  null
  
)

export default component.exports